module.exports = "https://static.wmbcdn.com/uniweb/images/b70c24f32c69f9a506c139d85400c0b2.svg";